var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperatingPerformance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 11.2,
    fill: "#FFE6D5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 39.25H18.75C18.0499 39.25 17.6999 39.25 17.4325 39.1138C17.1973 38.9939 17.0061 38.8027 16.8862 38.5675C16.75 38.3001 16.75 37.9501 16.75 37.25V18.75C16.75 18.0499 16.75 17.6999 16.8862 17.4325C17.0061 17.1973 17.1973 17.0061 17.4325 16.8862C17.6999 16.75 18.0499 16.75 18.75 16.75H22.25C22.9501 16.75 23.3001 16.75 23.5675 16.8862C23.8027 17.0061 23.9939 17.1973 24.1138 17.4325C24.25 17.6999 24.25 18.0499 24.25 18.75V21.75M24.25 39.25H31.75M24.25 39.25L24.25 21.75M24.25 21.75H29.75C30.4501 21.75 30.8001 21.75 31.0675 21.8862C31.3027 22.0061 31.4939 22.1973 31.6138 22.4325C31.75 22.6999 31.75 23.0499 31.75 23.75V39.25M31.75 26.75H37.25C37.9501 26.75 38.3001 26.75 38.5675 26.8862C38.8027 27.0061 38.9939 27.1973 39.1138 27.4325C39.25 27.6999 39.25 28.0499 39.25 28.75V37.25C39.25 37.9501 39.25 38.3001 39.1138 38.5675C38.9939 38.8027 38.8027 38.9939 38.5675 39.1138C38.3001 39.25 37.9501 39.25 37.25 39.25H31.75",
    stroke: "#DC6803",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatingPerformance);
export default __webpack_public_path__ + "static/media/operating-performance.e80ae631a657e641b21ccb6b2c0e35e9.svg";
export { ForwardRef as ReactComponent };